import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "warehouse-form" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"980px"}
}
const _hoisted_3 = {
  key: 0,
  class: "form-grid"
}
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "item-card item-summary" }
const _hoisted_7 = { class: "item-photo-wrap" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "item-photo item-photo-empty"
}
const _hoisted_10 = { class: "item-meta" }
const _hoisted_11 = { class: "item-meta" }
const _hoisted_12 = { class: "item-card" }
const _hoisted_13 = { class: "item-meta" }
const _hoisted_14 = { class: "item-meta" }
const _hoisted_15 = { class: "item-meta" }
const _hoisted_16 = {
  key: 0,
  class: "image-grid"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "item-card"
}
const _hoisted_19 = {
  key: 1,
  class: "form-grid"
}
const _hoisted_20 = { class: "input-field" }
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = { class: "actions" }
const _hoisted_23 = {
  key: 1,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.damage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _cache[5] || (_cache[5] = _createElementVNode("h2", {
                  class: "title",
                  style: {"font-size":"22px"}
                }, "Detalhe da avaria", -1)),
                _createElementVNode("p", _hoisted_5, "Status: " + _toDisplayString(_ctx.damage.status), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.item?.photoDataUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "item-photo",
                      src: _ctx.$resolveUrl(_ctx.item?.photoDataUrl),
                      alt: "foto item"
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, "Sem foto"))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.item?.name || _ctx.damage.toolItemId), 1),
                _createElementVNode("div", _hoisted_10, "ID: " + _toDisplayString(_ctx.item?.code || _ctx.damage.toolItemId), 1),
                _createElementVNode("div", _hoisted_11, "Resumo: " + _toDisplayString(_ctx.damage.damageSummary || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Projeto:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.damage.projectId || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Colaborador:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.damage.collaboratorUsername || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Descricao:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.damage.damageDetails || _ctx.damage.description || '-'), 1)
              ])
            ]),
            (_ctx.damage.photoDataUrls && _ctx.damage.photoDataUrls.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damage.photoDataUrls, (img, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `damage-detail-${index}`,
                      class: "image-preview"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.resolveUrl(img),
                        alt: "foto avaria"
                      }, null, 8, _hoisted_17)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.canResolve && _ctx.damage.status !== 'resolvido')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (!_ctx.showResolveForm)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showResolveForm = true))
                      }, " Foi solucionado "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "resolution-notes" }, "Descricao do que foi feito", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            id: "resolution-notes",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resolutionNotes) = $event)),
                            rows: "4"
                          }, null, 512), [
                            [_vModelText, _ctx.resolutionNotes]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resolveDamage && _ctx.resolveDamage(...args)))
                          }, "Salvar"),
                          _createElementVNode("button", {
                            class: "btn btn-ghost",
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelResolve && _ctx.cancelResolve(...args)))
                          }, "Cancelar")
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, "Voltar")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, "Avaria nao encontrada."))
    ])
  ]))
}